import { Trans, useTranslation } from 'react-i18next';
import { FontWeight, LiliButton, Text, Heading } from '@lili/lili-frontend-common';
import { ILiliPlan } from '../../types';
import { STYLES, TEXT } from '../../constants';
import { convertValueToUSD, formatValueWithoutCurrency } from '../../../../helpers/currency.helper';
import { ReactComponent as PremiumWave } from '../../../../assets/svg/premium_wave.svg';
import { ReactComponent as PremiumCard } from '../../../../assets/svg/premium_card.svg';
import { ReactComponent as PremiumTitle } from '../../../../assets/svg/premium_title.svg';

interface IProps {
  plan: ILiliPlan;
  onUpgradeClick: (plan: ILiliPlan) => void;
  isLoading: boolean;
  disabled: boolean;
  isAnnual: boolean;
}

export const PremiumPlanInfoView = ({ plan, onUpgradeClick, isLoading, disabled, isAnnual }: IProps) => {
  const { t } = useTranslation();
  const priceBeforeDiscount = plan.annualData ? plan.annualData?.priceBeforeDiscount : undefined;
  const price = isAnnual && plan.annualData ? plan.annualData.price : plan.price;
  const formattedPrice = formatValueWithoutCurrency(price, 2);

  return (
    <div className={`${STYLES.INDEX.PLAN_PICKER.PLAN.INFO} bg-[#04172C]`} id='premiumBackground'>
      <div
        className={`items-center h-[30px] w-full  rounded-t-sm  ${plan.badge !== undefined ? 'bg-action05' : 'bg-action03'}`}
      >
        <Heading.H10 className='text-text-main-primary-inverse flex justify-center mt-[6px]'>
          {plan.badge || ''}
        </Heading.H10>
      </div>
      <PremiumTitle className='my-[32px]' />
      <span
        className={`flex flex-row text-text-main-primary-inverse ${isAnnual && priceBeforeDiscount ? 'mb-[3px]' : 'mb-[27px]'}`}
      >
        <Heading.H10 fontWeight={FontWeight.MEDIUM} className='text-inherit self-start mr-[2px]'>
          $
        </Heading.H10>
        <Heading.H4 fontWeight={FontWeight.MEDIUM} className='text-inherit leading-[28px]'>
          {formattedPrice}
        </Heading.H4>
        <Heading.H12 fontWeight={FontWeight.MEDIUM} className='text-inherit self-end'>
          {isAnnual ? t('PLAN_UPGRADE.PLAN_PICKER.PRICE_PER_YEAR') : t('PLAN_UPGRADE.PLAN_PICKER.PRICE_PER_MONTH')}
        </Heading.H12>
      </span>
      {isAnnual && priceBeforeDiscount && (
        <Text.H10 fontWeight={FontWeight.MEDIUM} className='text-text-main-tertiary-inverse mt-[8px] leading-[16px]'>
          <Trans
            i18nKey='PLAN_UPGRADE.PLAN_PICKER.PREV_PRICE'
            t={t}
            values={{
              priceBeforeDiscount: convertValueToUSD(priceBeforeDiscount, 2),
            }}
            components={{ span: <span /> }}
          />
        </Text.H10>
      )}
      <div className='relative'>
        <PremiumWave className='mt-[32px]' />
        <div className='w-full top-0 absolute  flex flex-col items-center'>
          <PremiumCard />
        </div>
      </div>
      <LiliButton
        id='planPickerTab'
        isLoading={isLoading}
        title={t(TEXT.PLAN_PICKER.UPGRADE_BUTTON)}
        onClick={() => onUpgradeClick(plan)}
        className='w-[346px] h-[64px]'
        disabled={disabled}
      />
      <Text.H10 className='text-center text-text-main-primary-inverse mt-[24px] mb-[42px]'>
        {t('PLAN_UPGRADE.PLAN_PICKER.NO_MIN_DEPOSIT')}
      </Text.H10>
      <Text.H10 className='text-text-main-primary-inverse w-[346px] text-center'>{plan.description}</Text.H10>
    </div>
  );
};
